module.exports = __webpack_public_path__ + "static/media/b1.f4a9b8f5.png";